import { isArray } from 'lodash';
import type { JSX } from 'react';

import { Json } from '@/lib/types';

import { ChartData, GroupedChartData } from './types';

import styles from './grouped-chart.module.scss';

interface GroupedChartProps<T extends ChartData> {
  width: number;
  widthPerGroup: number;
  data: GroupedChartData<T>;
  groupFilters?: { key: string; value: Json }[];
  renderChart: (
    data: T,
    chartWidth: number,
    groupFilters: { key: string; value: Json }[],
  ) => JSX.Element;
}

export const GroupedChart = <T extends ChartData>(props: GroupedChartProps<T>) => {
  const { width, widthPerGroup, data, renderChart, groupFilters = [] } = props;

  if (isArray(data)) {
    return (
      <div>
        {data.map((child, idx) => (
          <div key={idx} className={styles.group}>
            <div className={styles.groupLabel} style={{ width: `${widthPerGroup}px` }}>
              {child.label}
            </div>
            <GroupedChart
              {...props}
              data={child.items}
              width={width - widthPerGroup}
              groupFilters={[
                ...groupFilters,
                {
                  key: child.key,
                  value: child.value,
                },
              ]}
            />
          </div>
        ))}
      </div>
    );
  }

  return width > 0 ? renderChart(data.chartData, width, groupFilters) : <></>;
};
